module.exports = __webpack_public_path__ + "img/logo_mediana_services.d08614e3.png";